//? Library Imports ------------------------------------------------------------>
import { useState } from "react";
import { useSelector } from "react-redux";
import {
  Col,
  Row,
  Tag,
  Space,
  Typography,
  Image,
  Modal,
  Form,
  Input,
  Button,
  message,
} from "antd";
import PhoneInput from "react-phone-input-2";
import Cookies from "js-cookie";

//? Assets --------------------------------------------------------------------->
import "./WishlistCard.scss";
import { CloseOutlined } from "@ant-design/icons";

//? Modules -------------------------------------------------------------------->
import DynamicButton from "@/components/shared/Buttons/DynamicButton/DynamicButton";
import { removeCommasAndConvertToNumber } from "@/functions/HelperFunctions";
import defaultImage from "../../../../assets/images/defaultImages/alfa-loader.gif";

//? Library Constants ---------------------------------------------------------->
const { Text } = Typography;
// const defaultImage = "https://rb.gy/wi9shp";

export default function WishlistCard({
  WishListProduct,
  setProductDetail,
  setViewEditProductModal,
  removeProductFromWishlist,
}) {
  const cookiesCurrency = Cookies.get("defaultCurrencyName");
  const mainColor = Cookies.get("main_theme");
  const secondaryColor = Cookies.get("secondary_theme");
  //? Redux States --------------------------------------------------------------->
  const defaultCurrency = cookiesCurrency;
  //? States --------------------------------------------------------------------->
  const [ShowNotifyModal, setShowNotifyModal] = useState(false);

  const productVariant = WishListProduct?.variants?.find(
    (variant) => variant?.variant_detail?.sold_out === false
  );

  const showNotificationModal = () => {
    setShowNotifyModal(false);
  };

  const notifyUser = async (data) => {
    try {
      const body = {
        name: data?.full_name,
        email: data?.email,
        phone: data?.phoneNo,
        variant: WishListProduct?.variants[0]?.id,
      };

      const payload = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body),
      };

      const Notify = await fetch(
        process.env.NEXT_PUBLIC_BACKEND +
          `/storefront/add_product_to_notify_by_user?storefront=23`,
        payload
      );

      if (!Notify.ok) {
        throw new Error("NotifyUser API Failed!");
      }

      if (Notify?.ok) {
        setShowNotifyModal(false);
        message.success("Notification Enabled Successfully!");
      } else {
        setShowNotifyModal(false);
        message.success("Notification Enabled Successfully!");
      }
    } catch (error) {
      setShowNotifyModal(false);
      message.success("Notification Enabled Successfully!");
      console.error("Error:", error.message);
    }
  };
  const discountPercentage = () => {
    const originalPrice = removeCommasAndConvertToNumber(
      productVariant?.variant_detail?.original_price
    );
    const discountedPrice = removeCommasAndConvertToNumber(
      productVariant?.variant_detail?.discounted_price
    );

    if (originalPrice && discountedPrice && originalPrice !== 0) {
      const percentageOff = Math.round(
        ((originalPrice - discountedPrice) / originalPrice) * 100
      );
      return `${percentageOff}% OFF`;
    }

    return "";
  };
  return (
    <Col className="WishlistCard">
      <Row gutter={0} justify="space-between" className="gap5">
        <Col flex="0 0 auto">
          <Image
            // width="121px"
            // height="142px"
            width={"100%"}
            height={"auto"}
            preview={false}
            alt="Wishlist Product"
            src={
              WishListProduct?.images[0]?.cdn_link
                ? WishListProduct?.images[0]?.cdn_link
                : defaultImage
            }
          />
        </Col>

        <Col flex="0 0 75%">
          <Row justify={"space-between"} className="width100">
            <Col span={23}>
              <Row className="card-details width100">
                <Col span={24}>
                  <Space direction="vertical" className="gap5">
                    <Space direction="vertical" size="small">
                      <Text
                        className="font14Bold"
                        style={{
                          width: "100%",
                          color: "#000000",
                          maxWidth: "300px",
                          overflow: "hidden",
                          whiteSpace: "nowrap",
                          display: "inline-block",
                          textOverflow: "ellipsis",
                        }}
                      >
                        {WishListProduct?.title
                          ? WishListProduct?.title
                          : "N/A"}
                      </Text>

                      <Col flex="1 1 auto">
                        {removeCommasAndConvertToNumber(
                          productVariant?.variant_detail?.discounted_price
                        ) <=
                        removeCommasAndConvertToNumber(
                          productVariant?.variant_detail?.original_price
                        ) ? (
                          <Row style={{ overflow: "hidden" }}>
                            <Col>
                              <Text className="font14Bold">
                                {defaultCurrency}
                                &nbsp;
                                {productVariant?.variant_detail
                                  ?.discounted_price
                                  ? productVariant?.variant_detail
                                      ?.discounted_price
                                  : "N/A"}
                              </Text>
                            </Col>

                            {removeCommasAndConvertToNumber(
                              productVariant?.variant_detail?.discounted_price
                            ) <
                            removeCommasAndConvertToNumber(
                              productVariant?.variant_detail?.original_price
                            ) ? (
                              <Space className="paddingLeft5">
                                <Text className="font14Bold priceCut">
                                  {defaultCurrency}
                                  &nbsp;
                                  {productVariant?.variant_detail
                                    ?.original_price
                                    ? productVariant?.variant_detail
                                        ?.original_price
                                    : "N/A"}
                                </Text>
                                {/* {removeCommasAndConvertToNumber(
                                  productVariant?.variant_detail
                                    ?.discounted_price
                                ) <
                                  removeCommasAndConvertToNumber(
                                    productVariant?.variant_detail
                                      ?.original_price
                                  ) && (
                                  <Tag className="discountTag alignCenter borderNone borderRadius0 font16 poppinsLight">
                                    {discountPercentage()}
                                  </Tag>
                                )} */}
                              </Space>
                            ) : null}
                          </Row>
                        ) : null}
                      </Col>
                      <Col span={24}>
                        <Text className="font12 poppinsMedium">
                          SKU:{" "}
                          {productVariant?.sku
                            ? productVariant?.sku
                            : WishListProduct?.variants[0]?.sku
                            ? WishListProduct?.variants[0]?.sku
                            : "N/A"}
                        </Text>
                      </Col>
                    </Space>
                  </Space>
                </Col>

                <Col
                  span={24}
                  className="marginTop10"
                  // style={{ display: "flex", alignItems: "end" }}
                >
                  {WishListProduct?.sold_out ? (
                    <Col flex="49%" onClick={() => setShowNotifyModal(true)}>
                      <DynamicButton
                        name="Notify on Restock"
                        className="addToCart"
                        style={{
                          color: "white",
                          fontSize: "12px",
                          background: "black",
                        }}
                      />
                    </Col>
                  ) : (
                    <DynamicButton
                      name="Add to Cart"
                      className="addToCart"
                      style={{
                        color: mainColor,
                        borderColor: mainColor,
                      }}
                      function={() => {
                        setProductDetail(WishListProduct),
                          setViewEditProductModal(true);
                      }}
                    />
                  )}
                </Col>
              </Row>
            </Col>
            <Modal
              footer={null}
              // open={true}
              open={ShowNotifyModal}
              title="Notify on Restock"
              // className="NotifyModal"
              wrapClassName="NotifyModal"
              onCancel={showNotificationModal}
            >
              <Col span={24}>
                <Form
                  size="large"
                  layout="vertical"
                  name="notify_form"
                  onFinish={notifyUser}
                  className="notify_form"
                  initialValues={{
                    remember: true,
                  }}
                  style={{
                    width: "100%",
                  }}
                >
                  <Col>
                    <Text className="font16">Name</Text>
                    <Form.Item
                      // label="Name"
                      name="full_name"
                      style={{ margin: "10px 0px" }}
                      rules={[
                        {
                          required: true,
                          message: "Please enter a valid name!",
                        },
                        { min: 3, message: "Too Short!" },
                        { max: 20, message: "Too Long!" },
                        {
                          pattern: /^[aA-zZ\s]+$/,
                          message: "Only alphabets are allowed for this field ",
                        },
                      ]}
                    >
                      <Input placeholder="Full Name" />
                    </Form.Item>

                    <Text className="font16">Email</Text>
                    <Form.Item
                      // label="Email"

                      name="email"
                      style={{ margin: "10px 0px" }}
                      rules={[
                        {
                          required: true,
                          message: "Please enter a valid email!",
                        },
                        {
                          pattern:
                            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                          message: "Please enter a valid email!",
                        },
                      ]}
                    >
                      <Input placeholder="John@example.com" />
                    </Form.Item>

                    <Text className="font16">Mobile</Text>
                    <Form.Item
                      // label="Mobile"
                      name="phoneNo"
                      className="marginTop10"
                      rules={[
                        {
                          required: true,
                        },
                      ]}
                    >
                      <PhoneInput country={"pk"} />
                    </Form.Item>
                  </Col>
                  <Form.Item>
                    <Button
                      block
                      type="primary"
                      htmlType="submit"
                      style={{
                        height: "40px",
                        fontWeight: 600,
                        fontSize: "16px",
                        // minWidth: "422px",
                        marginTop: "20px",
                        borderRadius: "6px",
                        background: "black",
                      }}
                    >
                      Notify on Restock
                    </Button>
                  </Form.Item>
                </Form>
              </Col>
            </Modal>

            <Col span={1}>
              <CloseOutlined
                onClick={() => removeProductFromWishlist(WishListProduct?.id)}
              />
            </Col>
          </Row>
        </Col>
      </Row>
    </Col>
  );
}
